// 배송조회 사용자 타입
export const Operator = {
    /** 구매자 */
    CUSTOMER: 'CUSTOMER',
    /** 판매자 */
    SELLER: 'SELLER',
} as const

// 배송조회 사용자 타입
export type OperatorType = Constant<typeof Operator>

export const TrackingEvent = {
    /** 발송 */
    DISPATCH: 'DISPATCH',
    /** 수거 요청 */
    COLLECT_REQUEST: 'COLLECT_REQUEST',
    /** 수거 대기 */
    COLLECT_WAIT: 'COLLECT_WAIT',
    /** 집화 실패 */
    COLLECT_CARGO_FAIL: 'COLLECT_CARGO_FAIL',
    /** 집화 */
    COLLECT_CARGO: 'COLLECT_CARGO',
    /** 집화 취소 */
    COLLECT_CARGO_CANCEL: 'COLLECT_CARGO_CANCEL',
    /** 배송 중 */
    DELIVERING: 'DELIVERING',
    /** 지점 도착 */
    BRANCH_ARRIVAL: 'BRANCH_ARRIVAL',
    /** 도착 예정 */
    ESTIMATED_ARRIVAL: 'ESTIMATED_ARRIVAL',
    /** 배송 실패 */
    DELIVERY_FAIL: 'DELIVERY_FAIL',
    /** 배송 완료 */
    DELIVERY_COMPLETION: 'DELIVERY_COMPLETION',
    /** 오류 송장 */
    WRONG_INVOICE: 'WRONG_INVOICE',
    /** 배송 추적 없음 */
    NOT_TRACKING: 'NOT_TRACKING',
}

export type TrackingEventType = Constant<typeof TrackingEvent>

/** 배송 방향 */
export const DeliveryDirection = {
    /** 정배송 */
    ORIGINAL: 'ORIGINAL',
    /** 재배송/교환 */
    REDELIVERY: 'REDELIVERY',
    /** 반품배송 */
    COLLECT_DELIVERY: 'COLLECT_DELIVERY',
}
export type DeliveryDirectionType = Constant<typeof DeliveryDirection>

/** 배송 방법 */
export const DeliveryMethod = {
    /** 일반택배 */
    DELIVERY: 'DELIVERY',
    /** 도착보장 */
    ARRIVAL_GUARANTEE: 'ARRIVAL_GUARANTEE',
    /** 배송시뮬레이터 */
    SIMULATOR: 'SIMULATOR',
    /** 장보기 */
    BRANCH_DELIVERY: 'BRANCH_DELIVERY',
    /** 퀵커머스 즉시배달 */
    QUICK_COMMERCE_INSTANT: 'QUICK_COMMERCE_INSTANT',
    /** 퀵커머스 픽업 */
    QUICK_COMMERCE_PICKUP: 'QUICK_COMMERCE_PICKUP',
    /** 추적불가 일반택배 */
    DELIVERY_NO_TRACKING: 'DELIVERY_NO_TRACKING',
    /** 직접전달 */
    DIRECT_DELIVERY: 'DIRECT_DELIVERY',
    /** 퀵서비스 (오토바이 등) */
    QUICK_SERVICE: 'QUICK_SERVICE',
    /** 방문수령 */
    SELF_PICKUP: 'SELF_PICKUP',
}
export type DeliveryMethodType = Constant<typeof DeliveryMethod>

/** 배송 상태 */
export const DeliveryStatus = {
    /** 준비중 (발송처리) */
    READY: 'READY',
    /** 배송시작 (집하) */
    START: 'START',
    /** 배송 중 */
    IN_DELIVERY: 'IN_DELIVERY',
    /** 도착 예정 */
    ARRIVING_SOON: 'ARRIVING_SOON',
    /** 배송 완료 */
    COMPLETED: 'COMPLETED',
    /** 구매 확정 완료 */
    PURCHASE_CONFIRMED: 'PURCHASE_CONFIRMED',
    /** 배송 시작 (추적 불가) */
    NO_TRACKING_DELIVERY_STARTED: 'NO_TRACKING_DELIVERY_STARTED',
    /** 배송 완료 (추적 불가) */
    NO_TRACKING_DELIVERY_COMPLETED: 'NO_TRACKING_DELIVERY_COMPLETED',
    /** 구매 확정 완료 (추적 불가) */
    NO_TRACKING_PURCHASE_CONFIRMED: 'NO_TRACKING_PURCHASE_CONFIRMED',
    /** 배송 추적 데이터 만료 */
    NO_TRACKING_EXPIRED: 'NO_TRACKING_EXPIRED',
    /** 조회 실패 */
    FAILED: 'FAILED',
}
export type DeliveryStatusType = Constant<typeof DeliveryStatus>

/** 배송추적 대행사 */
export const InterlockingCorp = {
    /** 굿스플로 */
    GOODSFLOW: 'GOODSFLOW',
    /** 스윗트래커 */
    SWEETTRACKER: 'SWEETTRACKER',
    /** CJ대한통운 */
    CJGLS: 'CJGLS',
    /** 장보기 */
    MARKET: 'MARKET',
    /** 물류사 직접연동 */
    LOGISTICS: 'LOGISTICS',
}

export type InterlockingCorpType = Constant<typeof InterlockingCorp>
